import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function uploadFile(file: File) {
  let formData = new FormData();

  formData.append('file', file);

  return fetchWrapper(
    endpoint + `/v1/files`,
    {
      method: 'post',
      body: formData,
    },
    false,
  ).then((res) => res.json());
}

export async function deleteFiles(files: string[]) {
  return fetchWrapper(endpoint + `/v1/files`, {
    method: 'delete',
    body: JSON.stringify({ files }),
  });
}
